export const hcExtra = {
  reservas: {
    buscar: "بحث",
    limpiar: "مسح",
    todas: "الكل",
  },
  nav: {
    volver: "رجوع",
  },
  listingDetail: {
    badgeNew: "جديد",
  },
  ofertas: {
    precio: "السعر",
  },
  payService: {
    sendRequest: "إرسال الطلب",
  },
  accountCfg: {
    accountEmail: "بريد الحساب",
  },
};
